import * as React from 'react';
import Swipe from 'swipejs/types/swipe';

import Error from './Error';
import Slider from './Slider';
import Navigation from './Navigation';
import Zoomer from './Zoomer';
import MediaElement from './MediaElement';
import { MediaSet, ZoomedImage } from '../../../../types';

const { viewerMediaSet, viewerMaxPercentage } = window.globalProductDetails;

function changeModelImagePosition(mediaSet: MediaSet, position = 1): MediaSet {
  const modelItem = mediaSet.items?.find((item) => item.model);

  if (!modelItem || position < 0 || position > mediaSet.items?.length) {
    return mediaSet;
  }

  const items = mediaSet.items.filter((item) => !item.model);
  items.splice(position, 0, modelItem);

  return {
    ...mediaSet,
    items
  };
}

const sortedMediaSet = viewerMediaSet ? changeModelImagePosition(viewerMediaSet) : null;

function MobileMediaGallery(): React.ReactElement {
  const viewerInstance = React.useRef<Swipe | null>(null);
  const [slideIndex, setSlideIndex] = React.useState<number>(0);
  const [zoomedImage, setZoomedImage] = React.useState<ZoomedImage | undefined>(undefined);

  const goToSlide = React.useCallback(
    (index: number, instance: React.MutableRefObject<Swipe | null>, speed = 300): void =>
      instance.current?.slide(index, speed),
    []
  );

  return (
    <div className="viewer">
      <Error>
        <div className="viewer__container">
          {zoomedImage && (
            <Zoomer
              zoomedImage={zoomedImage}
              setZoomedImage={setZoomedImage}
              viewerMaxPercentage={viewerMaxPercentage}
            />
          )}
          <Slider instance={viewerInstance} setSlideIndex={setSlideIndex}>
            {sortedMediaSet &&
              sortedMediaSet.items.map((media, index) => (
                <div className="swipe-wrap__item" key={`item_${index + 1}`}>
                  <MediaElement
                    index={index}
                    media={media}
                    className="gallery-mobile__media"
                    setZoomedImage={media.type === 'img' ? setZoomedImage : undefined}
                    disableTouchOnSet
                    recurrentSet
                    autoplay
                  />
                </div>
              ))}
          </Slider>
        </div>
        <Navigation
          mediaSet={sortedMediaSet}
          slideIndex={slideIndex}
          goToSlide={(index: number): void => goToSlide(index, viewerInstance)}
        />
      </Error>
    </div>
  );
}

export default MobileMediaGallery;
